import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const RouteLegend = () => {
    const routes = useSelector((state) => state.winterDutyState.routes);

    const components = routes.map((route) => {
        const style = { color: route.hexColor };
        return (
            <li className='legend' key={route.name} style={style}>
                <p>{route.name}</p>
            </li>
        );
    });

    return (
        <ul className="route-legend-container">
            {components}
        </ul>
    );
};

export default RouteLegend;